import type { MaybeRef } from 'vue';

export const baremetalKeys = {
  all: ['baremetal'] as const,
  servers: () => [...baremetalKeys.all, 'servers'] as const,
  server: (id: number) => [...baremetalKeys.all, 'server', id] as const,
  baremetalTask: (id: number) => [...baremetalKeys.all, 'baremetal-task', id] as const,
  dataForCreate: () => [...baremetalKeys.all, 'data-for-create'] as const,
  history: (id: MaybeRef<number>, params: MaybeRef<{ page?: number; query?: string }>) =>
    [...baremetalKeys.all, 'history', id, params] as const,
};
